// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vzd-no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px;
  color: #999;
}

.vzd-no-results ion-icon {
  font-size: 48px;
}

.vzd-results-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vzd-result-item {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.vzd-result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.vzd-result-header:hover {
  background-color: #f9fafb;
}

.vzd-result-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.vzd-result-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
}

.vzd-result-qualifications {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.vzd-qualification-badge {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  color: #4b5563;
  background-color: #f3f4f6;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.vzd-result-org {
  font-size: 13px;
  color: #6b7280;
}

.vzd-result-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.vzd-endpoint-count {
  font-size: 12px;
  color: #9ca3af;
}

.vzd-result-meta ion-icon {
  font-size: 18px;
  color: #9ca3af;
}

/* Endpoint list styles */
.vzd-endpoint-list {
  border-top: 1px solid #e5e7eb;
  background-color: #fafafa;
}

.vzd-endpoint-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.vzd-endpoint-item:last-child {
  border-bottom: none;
}

.vzd-endpoint-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.vzd-endpoint-name {
  font-size: 13px;
  color: #374151;
}

.vzd-endpoint-address {
  font-size: 12px;
  color: #6b7280;
  word-break: break-all;
}

.vzd-endpoint-label {
  font-weight: 500;
  color: #555;
}

.vzd-invite-button {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
  background-color: var(--netsfere-red);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
  flex-shrink: 0;
  margin-left: 12px;
}

.vzd-invite-button:hover:not(:disabled) {
  background-color: #b82419;
}

/* Invited state: outlined "Remove" button */
.vzd-invite-button--invited {
  background-color: #fff;
  color: var(--netsfere-red);
  border: 1px solid var(--netsfere-red);
}

.vzd-invite-button--invited:hover:not(:disabled) {
  background-color: #fef2f2;
  color: #b82419;
  border-color: #b82419;
}

.vzd-invite-button:disabled {
  background-color: #ed9a9a;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/VzdSearch/VzdSearchResults.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".vzd-no-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 40px;\n  color: #999;\n}\n\n.vzd-no-results ion-icon {\n  font-size: 48px;\n}\n\n.vzd-results-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.vzd-result-item {\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.vzd-result-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: background-color 0.15s;\n}\n\n.vzd-result-header:hover {\n  background-color: #f9fafb;\n}\n\n.vzd-result-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n  flex: 1;\n}\n\n.vzd-result-name {\n  font-size: 14px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.vzd-result-qualifications {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.vzd-qualification-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  font-size: 11px;\n  color: #4b5563;\n  background-color: #f3f4f6;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n}\n\n.vzd-result-org {\n  font-size: 13px;\n  color: #6b7280;\n}\n\n.vzd-result-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.vzd-endpoint-count {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.vzd-result-meta ion-icon {\n  font-size: 18px;\n  color: #9ca3af;\n}\n\n/* Endpoint list styles */\n.vzd-endpoint-list {\n  border-top: 1px solid #e5e7eb;\n  background-color: #fafafa;\n}\n\n.vzd-endpoint-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.vzd-endpoint-item:last-child {\n  border-bottom: none;\n}\n\n.vzd-endpoint-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.vzd-endpoint-name {\n  font-size: 13px;\n  color: #374151;\n}\n\n.vzd-endpoint-address {\n  font-size: 12px;\n  color: #6b7280;\n  word-break: break-all;\n}\n\n.vzd-endpoint-label {\n  font-weight: 500;\n  color: #555;\n}\n\n.vzd-invite-button {\n  padding: 6px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #fff;\n  background-color: var(--netsfere-red);\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  flex-shrink: 0;\n  margin-left: 12px;\n}\n\n.vzd-invite-button:hover:not(:disabled) {\n  background-color: #b82419;\n}\n\n/* Invited state: outlined \"Remove\" button */\n.vzd-invite-button--invited {\n  background-color: #fff;\n  color: var(--netsfere-red);\n  border: 1px solid var(--netsfere-red);\n}\n\n.vzd-invite-button--invited:hover:not(:disabled) {\n  background-color: #fef2f2;\n  color: #b82419;\n  border-color: #b82419;\n}\n\n.vzd-invite-button:disabled {\n  background-color: #ed9a9a;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
